import { AirplaneIcon } from './AirplaneIcon';

/**
 * author: Colton Wiscombe
 * id 5AE3D483-1E1C-49DE-92FF-21C6B93FD52F
 * name airplane
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane.svg
 * tags
 * - Transportation + Flying 
 * - Navigation 
 */
export const AeroplaneIcon = AirplaneIcon;
export default AeroplaneIcon